module.exports = __webpack_public_path__ + "img/loom.ee77132f.svg";